import * as React from 'react';

import MentionCardHeader from 'components/mention-card/mention-card-header/MentionCardHeader';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';

applyTranslations(require('components/mention-card/mention-card-header/mention-card-header.i18n.json'));

class MentionCardHeaderYoutube extends MentionCardHeader {
  renderSubscribers(): React.ReactNode {
    const { post } = this.props;

    return (
      <div className="mention-card-header__audience">
        ({abbrNum(post.subscribers)} {__t('mention_card_header.youtube.label_subscribers')})
      </div>
    );
  }

  render(): React.ReactNode {
    const { post } = this.props;
    const username = (post && post.channelTitle) || '';

    return (
      <div
        className="mention-card-header mention-card-header--youtube"
        data-qa="mention-card-header-youtube"
      >
        {
          this.isPostReadyForUse() &&
            this.renderAvatar('youtube')
        }
        {
          username &&
            this.renderUsername(username, 'youtube')
        }
        {
          post && Number(post.subscribers) > 0 &&
            this.renderSubscribers()
        }
        {
          this.renderIconLink('youtube')
        }
        {
          this.renderContextMenu()
        }
      </div>
    );
  }
}

export default MentionCardHeaderYoutube;
